<template>
  <div>
    <div class="title h5 pt-3 pb-3">Recover account</div>
    <div class="form">
      <div class="recover-buttons" v-if="!passwordForm && !usernameForm">
        <SButtonMaterial
          class="recover-action"
          buttonType="button"
          color="primary"
          size="default"
          textColor="white"
          materialClass="dense"
          text="i forgot my username"
          @button="forgotUsername"
        />
        <SButtonMaterial
          class="recover-action"
          buttonType="button"
          color="primary"
          textColor="white"
          size="default"
          materialClass="dense"
          text="i forgot my password"
          @button="forgotPassword"
        />
      </div>
      <SRecoverPasswordForm @forgot="$emit('forgot-password')" ref="forgotPassword" v-if="passwordForm"/>
      <SRecoverUsernameForm @forgot="$emit('forgot-username')" ref="forgotUsername" v-if="usernameForm"/>
    </div>
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SRecoverPasswordForm from "@/material-components/molecules/SRecoverPasswordForm.vue";
import SRecoverUsernameForm from "@/material-components/molecules/SRecoverUsernameForm.vue";
export default {
  name: "SRecoverForm",
  data() {
    return {
      usernameForm: false,
      passwordForm: false,
    };
  },
  components: {
    SButtonMaterial,
    SRecoverPasswordForm,
    SRecoverUsernameForm,
  },
  computed: {

  },
  methods: {
    forgotUsername() {
      this.usernameForm = true;
      this.passwordForm = false;
    },
    forgotPassword() {
      this.passwordForm = true;
      this.usernameForm = false;
    },
    backToOptions() {
      this.passwordForm = false;
      this.usernameForm = false;
    },
  }
};
</script>

<style lang="scss">
.recover-buttons {
  width: 100%;
  margin-top: 3rem;
}

.recover-action {
  margin: 10px 0;
  width: 100%;
  margin-bottom: 2rem !important;
}
</style>
